import { ExternalLink } from 'lucide-react';

const categories = [
  {
    icon: '🍲',
    title: 'Comida Baiana',
    desc: 'Pratos típicos como moqueca, acarajé e vatapá, com temperos brasileiros que trazem o sabor da Bahia para Fortaleza.',
  },
  {
    icon: '🌶️',
    title: 'Culinária Nordestina',
    desc: 'Sabores do Nordeste em pratos que representam a tradição regional, com temperos marcantes e muito sabor.',
  },
  {
    icon: '🍤',
    title: 'Petiscos',
    desc: 'Petiscos perfeitos para acompanhar uma cerveja gelada e aproveitar o clima de buteco com os amigos.',
  },
  {
    icon: '🍹',
    title: 'Drinks e Coquetéis',
    desc: 'Coquetéis bem preparados, drinks clássicos e autorais para brindar e curtir a noite na Varjota.',
  },
  {
    icon: '🍺',
    title: 'Cervejas e Bebidas',
    desc: 'Cerveja gelada, opções variadas de bebidas e aquele chopp que faz a diferença no seu rolê.',
  },
  {
    icon: '🛵',
    title: 'Delivery',
    desc: 'Receba o sabor do Buteco do Baiano na sua casa. Confira disponibilidade e área de entrega pelo WhatsApp.',
  },
  {
    icon: '🎸',
    title: 'Música ao Vivo',
    desc: 'Noites embaladas por bons músicos, com um ambiente descontraído perfeito para curtir com os amigos.',
  },
  {
    icon: '😊',
    title: 'Ambiente Agradável',
    desc: 'Área Climatizada, cobertura, ambiente descontraído e um espaço pensado para o seu bem-estar e diversão.',
  },
];

export default function MenuSection() {
  return (
    <section id="sabores" className="py-16 md:py-24 bg-cream-100">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-7xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 md:mb-16 reveal">
            <span className="inline-block text-gold-500 text-xs font-semibold tracking-widest uppercase mb-3">
              NOSSOS SABORES
            </span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-900 mb-4">
              Cardápio e Experiência
            </h2>
            <p className="text-brown-600 text-base md:text-lg max-w-2xl mx-auto">
              Conheça as categorias que fazem do Buteco do Baiano um ponto de encontro na Varjota. Para o menu completo, acesse nosso cardápio digital.
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {categories.map((item, i) => (
              <div
                key={item.title}
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all duration-300 group reveal"
                style={{ transitionDelay: `${i * 0.05}s` }}
              >
                <div className="text-3xl mb-4">{item.icon}</div>
                <h3 className="font-heading text-lg font-bold text-brown-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-brown-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-10 reveal">
            <a
              href="https://playmenu.app/public/index.php?r=buteco-do-baiano&from=admin"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-yellow-500 text-white font-semibold rounded-full hover:bg-yellow-600 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap"
            >
              <ExternalLink size={18} />
              Ver cardápio
            </a>
            <p className="text-brown-500 text-xs mt-3">
              Cardápio digital completo no PlayMenu
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
